export const CRITICALITY_PRIORITY: Record<string, number> = {
  Critical: 3,
  Major: 2,
  Minor: 1
};

export const PRIORITY: Record<string, number> = {
  Urgent: 3,
  Medium: 2,
  Low: 1
};

export const CRITICALITY_COLORS: Record<string, string> = {
  Critical: '#e53935',
  Major: '#fb8c00',
  Minor: '#fdd835',
  Default: '#29b6f6'
};

export const PRIORITY_COLORS: Record<string, string> = {
  Urgent: '#e53935',
  Medium: '#fb8c00',
  Low: '#fdd835',
  Default: '#29b6f6'
};
